import {
	dashboardGetBusinessesSuccess,
	DashboardGetBusinessesSuccessProps
} from '@/modules/dashboard/dashboardActions';
import { useDispatch } from 'react-redux';

export const useBusinessDataMutation = () => {
	const dispatch = useDispatch();

	const setBusiness = (payload: DashboardGetBusinessesSuccessProps) => {
		dispatch(dashboardGetBusinessesSuccess(payload));
	};

	return { setBusiness };
};
